
/* injects from baggage-loader */

'use strict';

/**
 * Constants to use in the sellerCashierSearch module.
 */
const sellerCashierSearchConstant = {
	CASHIER_LABEL: 'Cajero',
	NOT_FOUND_SELLERS_CASHIERS: 'No se pudieron adquirir los vendedores o cajeros',
	SELLER_LABEL: 'Vendedor'
};

export default sellerCashierSearchConstant;



// WEBPACK FOOTER //
// ./src/app/core/components/sellerCashierSearch/sellerCashierSearch.constant.js